




















































import Vue, { PropType } from 'vue';
import { EventType } from '@/constants';
import { Member, User } from '@/types';
import { getInitials, ordinals } from '@/util';

export default Vue.extend({
  name: 'Recepients',
  props: {
    coBuyers: {
      type: Array as PropType<User[]>,
      required: true
    },
    teamMembers: {
      type: Array as PropType<Member[]>,
      required: true
    },
    selectedRecipients: {
      type: Object as PropType<any>,
      required: true
    }
  },
  data () {
    return {
      selectedCoBuyers: [] as User[],
      selectedTeamMembers: [] as Member[],
      ordinals,
      EventType
    }
  },
  mounted () {
    this.selectedRecipients.coBuyers.forEach((coBuyer: User) => this.selectedCoBuyers.push(coBuyer));
    this.selectedRecipients.teamMembers.forEach((member: Member) => this.selectedTeamMembers.push(member));
  },
  computed: {
    isSelectedRecipient (): boolean {
      return !!(this.selectedCoBuyers.length || this.selectedTeamMembers.length);
    }
  },
  methods: {
    fetchInitials (firstName: string, lastName: string) {
      return getInitials(firstName, lastName);
    },
    setRecipients () {
      this.$emit(EventType.SET_MESSAGE_RECIPIENTS, {
        coBuyers: this.selectedCoBuyers,
        teamMembers: this.selectedTeamMembers
      });
    },
    setCoBuyers (coBuyer: User) {
      const idx = this.isSelectedCoBuyer(coBuyer);
      if (idx > -1) {
        this.selectedCoBuyers.splice(idx, 1);
      } else {
        this.selectedCoBuyers.push(coBuyer);
      }
    },
    setTeamMembers (member: Member) {
      const idx = this.isSelectedMember(member);
      if (idx > -1) {
        this.selectedTeamMembers.splice(idx, 1);
      } else {
        this.selectedTeamMembers.push(member);
      }
    },
    isSelectedMember (member: Member) {
      return this.selectedTeamMembers.findIndex(teamMember => teamMember.userId === member.userId);
    },
    isSelectedCoBuyer (coBuyer: User) {
      return this.selectedCoBuyers.findIndex(cobuyer => cobuyer.email === coBuyer.email);
    }
  }
});
